<template>
  <div id="app">
    <Index />
  </div>
</template>

<script>
import Index from './views/index'

export default {
  name: 'App',
  components: {
    Index
  }
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  background-color: #000;
}
</style>
